import { Avatar, Box, Button, Typography } from '@mui/material';
import Dialog from '../../components/Dialog';
import { useLanguageContext } from '../../contexts/LanguageContext';
import Languages from '../../data/Languages';
import { useState } from 'react';


const ChangeLanguage = () => {
    const { translate, language, handleChangeLanguage } = useLanguageContext();
    
    const [open, setOpen] = useState<boolean>(false);

    return <>
        <Box className='card-changelanguage' onClick={() => setOpen(true)}>
            <Avatar src={language.icon} alt={language.text} className='changelanguage-avatar' />
            <Typography className='changelanguage-text'>{language.initials}</Typography>
        </Box>

        <Dialog 
            open={open}
            handleClose={() => setOpen(false)}
            title={translate('changeLanguage')}
            className='container-languagedialog'
            maxWidth='xs'
        >
            <Box className='display-flex flexdirection-column gap-8' paddingY={2}>
                {
                    Languages.map((l, index) => {
                        const className = l.value === language.value ? 'active' : '';

                        return <Button
                            className={`language-item ${className}`}
                            onClick={() => {
                                handleChangeLanguage(l.value);
                                setOpen(false);
                            }}
                            key={index}
                        >
                            <Avatar src={l.icon} alt={l.text} className='language-avatar' />
                            {translate(l.text)}
                        </Button>;
                    })
                }
            </Box>
        </Dialog>
    </>;
}

export default ChangeLanguage;